import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'
import * as React from 'react'
import { Auth0Provider, useAuth0 } from './auth0-context'
import { CartProvider } from './cart-context'
import { UserProvider } from './user-context'

const App = ({ children }) => {
  const { user } = useAuth0()
  const headers = user
    ? { Authorization: `Bearer ${user?.accessToken}` }
    : undefined

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    uri: process.env.GATSBY_ACCOUNTING_API,
    headers,
  })
  return (
    <ApolloProvider client={client}>
      <CartProvider>
        <UserProvider>{children}</UserProvider>
      </CartProvider>
    </ApolloProvider>
  )
}

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => (
  <Auth0Provider
    auth0Options={{
      domain: 'grand-casino-bern.eu.auth0.com',
      clientID: 'LNQT781KOsKcuuf7X5k5V9fQ95087oU3',
    }}
  >
    <App>{element}</App>
  </Auth0Provider>
)
